<template>
    <transition :name="transitionName">
        <keep-alive include="patients-library">
            <router-view @toggle-side-bar="toggleSideBar"></router-view>
        </keep-alive>
    </transition>
</template>

<script>
import PatientsSidemenu from './PatientsSidemenu.vue'
export default {
    name: 'patients',
    components: { PatientsSidemenu },
    data() {
        return {
            clickNotClose: true,
            sidebarActive: true,
            isCreated: false,
            transitionName: 'slide-fade-left',
            isSmallScreen: null
        }
    },
    watch: {
        $route(to, from) {
            if (from.path.indexOf(to.path) > -1) {
                // back nav
                this.transitionName = 'slide-swap-back'
            } else {
                this.transitionName = 'slide-swap'
            }
        },
        windowWidth() {
            this.setSidebarWidth()
        }
    },
    methods: {
        setSidebarWidth() {
            // Note: this.windowWidth is not being set
            this.windowWidth = window.innerWidth
            if (this.windowWidth < 992) {
                this.sidebarActive = this.clickNotClose = false
            } else {
                this.sidebarActive = this.clickNotClose = true
            }
        },
        toggleSideBar() {
            if (this.sidebarActive) {
                this.sidebarActive = false
            } else {
                this.sidebarActive = true
            }
        }
    },
    async mounted() {
        this.setSidebarWidth()
        this.isCreated = true
    }
}
</script>

<style scoped></style>

<style lang="scss">
@import '@/assets/scss/vuexy/apps/crm.scss';
</style>
